import { ArrowBackIosNew, ArrowCircleRightSharp, CheckCircle, HighlightOff } from '@mui/icons-material';
import { FormControlLabel, Radio, RadioGroup } from '@mui/material';
import { useContext, useEffect, useState } from "react";
import { CurrentPContext, MasterContext, MobiOrNotContext, OrdStageContext, OrderContext } from "../ContextApi/context";

import { useHistory } from "react-router-dom";
import ConnUrls from "../Connections/ConnectURL";
import MyDateTime from "../DTechComp/MyDateTime";
import J5ClientApprove from '../DTechComp/Pop_Fixed/J5ClientApprove';
import utilsRests from "../_Utils/utilsRests";
import OrderFunctions from "./OrderFunctions";
import myFunctions from '../myFunctions';
import { Helmet } from 'react-helmet';
import GetTheAddress from './GetTheAddress';
import PopUpTheComp from '../DTechComp/PopUpTheComp';
import PopUpClearComp from '../DTechComp/PopUpClearComp';
import FutureOrderPicker from './FutureOrderPicker';


const OrderTypeSelect = (props) => {



    const history = useHistory();
    const [order, setOrder] = useContext(OrderContext);
    const [currentPage, setCurrentPage] = useContext(CurrentPContext);
    const [mobiOrNot, setMobiOrNot] = useContext(MobiOrNotContext);
    const [master, setMaster] = useContext(MasterContext);

    const [ordStage, setOrdStage] = useContext(OrdStageContext);

    const [pageDisp, setPageDisp] = useState();
    const [shHid, setShHid] = useState((props.showHide != null ? props.showHide : true))

    const [doDeliver, setDoDeliver] = useState();
    const [doTakeAway, setDoTakeAway] = useState();
    const [thePopUp, setThePopUp] = useState("");

    // זרימת הבחירה החדשה - רלוונטית רק כשלעסק יש הזמנות עתידיות מופעלות.
    // אם אין, הזרימה נשארת בדיוק כמו היום (ניווט מיידי מהכרטיס).
    // הכל מוצג ברצף אחד באותו frame - אין מעברי מסך, רק הופעה/היעלמות של חלקים בהמשך הדף.
    const [selectedChannel, setSelectedChannel] = useState(null); // "Deliver" | "Take" | null
    const [orderMode, setOrderMode] = useState("now"); // "now" | "future"
    const [selectedSlot, setSelectedSlot] = useState(null);
    //האם הפופאפ פתוח כרגע - נפרד מ-orderMode כדי שאפשר יהיה לסגור אותו
    //(כפתור "אישור") בלי לדרוס את הבחירה ב"עתידי" שכבר נעשתה
    const [pickerOpen, setPickerOpen] = useState(false);


    useEffect(() => {

        refreshpage();

    }, [])

    const refreshpage = async () => {

        props.scrollToTop(10);
        props.shoTopStrp(false)
        props.setShowbanners(false)
        props.showfotter(false)

        let bk = await setCurrPage()
        setDoTakeAway(bk.Take);
        setDoDeliver(bk.Deliver);


    }


    useEffect(() => {

        if (order.Orders.length <= 0) {
            goToBack();
        }
        else {
            const go = async () => {
                let bk = await setCurrPage()
                setDoTakeAway(bk.Take);
                setDoDeliver(bk.Deliver);

                // setPageDisp(setThePag(bk));
            }
            go();
        }
    }, [props])



    const goToBack = () => {
        history.goBack();

        // if (document.referrer.indexOf(window.location.host) === -1) {
        // }
        // else {
        //      history.push('/'); }
    }


    const setCurrPage = async () => {

        let restPage = await utilsRests.getRestById(order.restId);

        //שלושת הערוצים בקריאה אחת
        const chans = MyDateTime.resolveBusinessChannels(restPage, master);

        //הבדיקה כאן התייחסה רק ל-Doing ולחסימות המאסטר והתעלמה
        //משעות הערוצים, ולכן משתמש היה מגיע למסך בחירה ריק.
        //אם עסק סגור כרגע אבל יש הזמנה עתידית זמינה - לא סוגרים, ממשיכים
        //למסך הבחירה כרגיל (שם תוצג רק אפשרות "הזמנה עתידית").
        if (!chans.canOrderNow && !(props.forceFutureMode || myFunctions.futureOrderAvailable(restPage, master))) {
            props.closePop();
        }

        setCurrentPage({ ...restPage, pageTYp: "withConPay" });
        if (!restPage.cardComCnt && restPage.gammaJ5) {
            setThePopUp(
                <J5ClientApprove okClick={() => setThePopUp()}
                    btnClick2={() => history.push(`/`)} />
            )
        }

        let Deliver = chans.deliveryOk;
        let Take = chans.takeAwayOk;

        return (
            { Deliver, Take }
        )

    }

    const goTakeAway = () => {
        order.OrderType = "Take"
        order.OrderTimes = currentPage.TakeAway?.Time
        order.OrderDelPrice = 0;
        order.Address = currentPage.buissAddress;
        setOrdStage(3);
        setOrder({ ...order });

        history.push("/MyOrder");
    }

    const goDelivery = () => {

        setThePopUp(
            <GetTheAddress
                theInsideComp={"bgLGray"}
                backFunc={true}
                allowBack={false}
                GoTOPay={() => continueToOrder()}
                closeMeFuc={() => setThePopUp()}
                goBackToMenu={() => { props.closePop() }}
                shoTopStrp={(tf) => { }}
                scrollToTop={(stUp) => { }} />
        )

    }

    const continueToOrder = () => {

        order.OrderType = "Deliver"
        order.OrderTimes = myFunctions.checkForDeliverysDelay(master, currentPage.Delivery?.Time, "Deliver") || 40;
        order.OrderDelPrice = order.deliveryAddress?.deliveryPrice;
        // order.Address = currentPage.buissAddress;
        setOrdStage(3);
        setOrder({ ...order });
        history.push("/MyOrder");
    }

    const backToRestMenu = () => {
        history.push(`/restaurants/${currentPage.pageUrlFix != null && currentPage.pageUrlFix != "" ?
            currentPage.pageUrlFix : currentPage._id}`)
    }

    //האם ניתן להפעיל הזמנות עתידיות לעסק הזה בכלל
    const futureOrdersEnabled = !!currentPage.futureOrdersEnabled;

    //ברירת המחדל בסכמה היא true - מסמכים ישנים שנוצרו לפני הוספת השדה
    //עשויים להיות undefined ולא false, ולכן !== false ולא בדיקת אמת ישירה
    const futureOrdersDeliveryOk = currentPage.futureOrdersDelivery !== false;
    const futureOrdersTakeAwayOk = currentPage.futureOrdersTakeAway !== false;

    //נראות הכרטיסים - פתוח עכשיו, או סגור עכשיו אך תומך בהזמנה עתידית
    const deliveryChannelVisible = (doDeliver || (futureOrdersEnabled && futureOrdersDeliveryOk)) &&
        !master.blockDeliverys.block &&
        Array.isArray(currentPage.cityesToDeliver) && currentPage.cityesToDeliver.length > 0;

    const takeAwayChannelVisible = (doTakeAway || (futureOrdersEnabled && futureOrdersTakeAwayOk)) &&
        !master.blockPickUps.block;

    const channelOpenNow = (channel) => channel === "Deliver" ? doDeliver : doTakeAway;
    const channelFutureCapable = (channel) => futureOrdersEnabled &&
        (channel === "Deliver" ? futureOrdersDeliveryOk : futureOrdersTakeAwayOk);

    //מבצע בפועל את בחירת הערוץ - futureSlot=null להזמנה רגילה, אחרת שעת היעד שנבחרה
    const finalizeChannel = (channel, futureSlot) => {
        order.isFutureOrder = !!futureSlot;
        order.scheduledFor = futureSlot ? futureSlot.toISOString() : null;
        if (channel === "Deliver") {
            goDelivery();
        } else {
            goTakeAway();
        }
    }

    //לחיצה על כרטיס - אם אין הזמנות עתידיות לעסק, ניווט מיידי בדיוק כמו היום.
    //אחרת, רק מסמן בחירה. שורת עכשיו/עתידי מוצגת רק אחרי שנבחר ערוץ (לא לפני
    //- ראה needsNowOrFutureChoice), כך שהברירת מחדל כאן תמיד "טרייה" ולא
    //עלולה לדרוס בחירה שהמשתמש כבר עשה מבלי שהוא יראה אותה (כי לפני בחירת
    //ערוץ הרדיו כלל לא מוצג)
    const onCardClick = (channel) => {
        if (!futureOrdersEnabled) {
            if (channel === "Deliver") goDelivery();
            else goTakeAway();
        } else {
            setSelectedChannel(channel);
            //פתוח עכשיו -> "עכשיו" ברירת מחדל (גם אם גם עתידי אפשרי).
            //סגור עכשיו -> לא בוחרים בשבילו; אם רק עתידי אפשרי המשתמש
            //ילחץ עליו בעצמו, ואם גם הוא לא אפשרי הכרטיס לא היה מוצג בכלל
            setOrderMode(channelOpenNow(channel) ? "now" : "");
            setSelectedSlot(null);
            setPickerOpen(false);
        }
    }

    //סגירת הפופאפ (X או לחיצה מחוץ לתוכן) בלי להשלים בחירה - לא משאירים slot
    //חלקי ולא את הרדיו מסומן על "הזמנה עתידית" בלי תאריך/שעה. חוזרים ל"עכשיו"
    //רק אם הערוץ באמת פתוח עכשיו, אחרת ל"לא נבחר" (אף רדיו לא מסומן) כי
    //"עכשיו" לא רלוונטי לערוץ הזה
    const closeFuturePicker = () => {
        setOrderMode(selectedChannel && channelOpenNow(selectedChannel) ? "now" : "");
        setSelectedSlot(null);
        setPickerOpen(false);
    }

    //כפתור "אישור" בתוך הפופאפ - תאריך+שעה כבר נבחרו, ממשיכים ישר לשלב הבא
    //(כתובת/תשלום), בדיוק כמו הכפתור "המשך" החיצוני להזמנה עתידית - בלי
    //לחזור למסך "סוג הזמנה"
    const confirmFuturePicker = () => {
        if (!selectedChannel || !selectedSlot) return;
        setPickerOpen(false);
        finalizeChannel(selectedChannel, selectedSlot);
    }

    //הכפתור התחתון היחיד בזרימה - מסיים הזמנה לעכשיו, או דורש slot נבחר להזמנה עתידית
    const onContinueClick = () => {
        if (!selectedChannel) return;
        if (orderMode === "future") {
            if (!selectedSlot) return;
            finalizeChannel(selectedChannel, selectedSlot);
        } else {
            finalizeChannel(selectedChannel, null);
        }
    }

    //שורת עכשיו/עתידי מוצגת רק אחרי שנבחר ערוץ - לא לפני, כדי שלא יהיה
    //אפשר "לבחור" הזמנה עתידית לפני שברור לאיזה ערוץ היא מתייחסת
    const needsNowOrFutureChoice = futureOrdersEnabled && !!selectedChannel;
    //אם כבר נבחר ערוץ שלא תומך בהזמנה עתידית (למשל איסוף כן, משלוח לא) -
    //אופציית "הזמנה עתידית" אפורה ולא לחיצה, לא רק נדרסת בשקט
    const futureOptionDisabled = !!selectedChannel && !channelFutureCapable(selectedChannel);
    //אם הערוץ שנבחר סגור עכשיו - "עכשיו" לא רלוונטי, אופציה עתידית היא היחידה
    const nowOptionDisabled = !!selectedChannel && !channelOpenNow(selectedChannel);
    //בורר התאריך/שעה תלוי בערוץ (שעות/slots שונים), ולכן ממתין לבחירת ערוץ.
    //pickerOpen נפרד מ-orderMode כדי שכפתור "אישור" יוכל לסגור את הפופאפ
    //בלי לאבד את הבחירה כבר-שנעשתה ב"עתידי"
    const showFuturePicker = selectedChannel && pickerOpen &&
        (orderMode === "future") && channelFutureCapable(selectedChannel);
    const continueDisabled = !selectedChannel || orderMode === "" ||
        (orderMode === "future" && !selectedSlot);

    return (
        <div>
            <div className={`OrderTypeSelectBlock ${shHid}`}>

                <h1 className={"SecondFontRegular bold anakMeod centerText"}>סוג הזמנה</h1>
                <div className={"FirstFont regular centerText"}>כבר מסיימים, בחר אופציה אחת</div>

                {deliveryChannelVisible ?
                    <button type="button"
                        className={`btnReset ORDTYLine ${selectedChannel === "Deliver" ? "selected" : ""}`}
                        onClick={() => onCardClick("Deliver")}>
                        {OrderFunctions.deliveryBlock2(`זמן משלוח: ${myFunctions.checkForDeliverysDelay(master, currentPage.Delivery?.Time, "Deliver")} דק'`,
                            currentPage,
                            order.deliveryAddress)}
                        <div className={"goOrdType"}>
                            {selectedChannel === "Deliver" ?
                                <CheckCircle aria-hidden="true" /> : <ArrowBackIosNew aria-hidden="true" />}
                        </div>
                    </button>
                    : ""}

                {takeAwayChannelVisible ?
                    <button type="button"
                        className={`btnReset ORDTYLine ${selectedChannel === "Take" ? "selected" : ""}`}
                        onClick={() => onCardClick("Take")}>
                        {OrderFunctions.takeAwayBlock2(`זמן הכנה: ${currentPage.TakeAway?.Time} דק'`, currentPage.buissAddress)}
                        <div className={"goOrdType"}>
                            {selectedChannel === "Take" ?
                                <CheckCircle aria-hidden="true" /> : <ArrowBackIosNew aria-hidden="true" />}
                        </div>
                    </button> : ""}

                {needsNowOrFutureChoice &&
                    <RadioGroup
                        className={"nowOrFutureRow"}
                        value={orderMode}
                        onChange={(e) => {
                            setOrderMode(e.target.value);
                            setSelectedSlot(null);
                            setPickerOpen(e.target.value === "future");
                        }}
                    >
                        <FormControlLabel value="now" disabled={nowOptionDisabled}
                            control={<Radio sx={{color: "#fec000","&.Mui-checked": {color: "#fec000",},}}/>} label="לעכשיו" />
                        <FormControlLabel value="future" disabled={futureOptionDisabled}
                            control={<Radio sx={{color: "#fec000","&.Mui-checked": {color: "#fec000",},}}/>} label="הזמנה עתידית" />
                    </RadioGroup>
                }

                {nowOptionDisabled &&
                    <div className={"regular centerText futureOnlyNotice"}>
                        העסק סגור כרגע, ניתן לבצע רק הזמנות עתידיות
                    </div>
                }

                {showFuturePicker &&
                    <div className={"futureTimePopupOverlay"} onClick={() => closeFuturePicker()}>
                        <div className={"futureTimePopupInner"} onClick={(e) => e.stopPropagation()}>
                            <button type="button" className={"btnReset sideClosBtn halfspin"} aria-label="סגור"
                                onClick={() => closeFuturePicker()}>
                                <HighlightOff aria-hidden="true" />
                            </button>
                            <FutureOrderPicker
                                rest={currentPage}
                                master={master}
                                channel={selectedChannel}
                                selectedSlot={selectedSlot}
                                onSelect={(slot) => setSelectedSlot(slot)}
                                onConfirm={() => confirmFuturePicker()}
                            />
                        </div>
                    </div>
                }

                {futureOrdersEnabled &&
                    <button type="button" className={"btnReset selectOpBtn futureContinueBtn"}
                        disabled={continueDisabled}
                        onClick={() => onContinueClick()}>
                        המשך
                    </button>
                }
            </div>

            {thePopUp}
            {/* <Helmet
                meta={[
                    {
                        property: "og:url", content: `${ConnUrls.siteDomainNam}/TakeOrDel`
                    }
                ]}>
                <link rel="canonical" href={`${ConnUrls.siteDomainNam}/TakeOrDel`} />
            </Helmet> */}
        </div>
    );
}

export default OrderTypeSelect;
